import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Layout from '../components/Layout';
import { numbersData } from '../data/numbers';
import { useSpeech } from '../hooks/useSpeech';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import '../pages/AlphabetDetail.css'; // Reuse styles

const NumberDetail = () => {
    const { number } = useParams();
    const history = useHistory();
    const { speak } = useSpeech();

    const itemIndex = numbersData.findIndex(i => i.value.toString() === number);
    const item = numbersData[itemIndex];

    useEffect(() => {
        if (item) {
            const timer = setTimeout(() => {
                speak(item.value.toString());
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [item, speak]);

    if (!item) return <Layout title="Error">Number not found</Layout>;

    const handleNext = () => {
        const nextIndex = (itemIndex + 1) % numbersData.length;
        history.push(`/numbers/${numbersData[nextIndex].value}`);
    };

    const handlePrev = () => {
        const prevIndex = (itemIndex - 1 + numbersData.length) % numbersData.length;
        history.push(`/numbers/${numbersData[prevIndex].value}`);
    };

    // Generate dots for counting
    const dots = Array.from({ length: item.value });

    return (
        <Layout title={`Number ${item.value}`} onBack={() => history.push('/numbers')}>
            <div key={number} className="alphabet-detail-container" style={{ backgroundColor: item.color }}>
                <div className="detail-card">
                    <div className="detail-letter">{item.value}</div>
                    <div className="detail-word">{item.word}</div>

                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '5px', marginTop: '20px' }}>
                        {dots.map((_, i) => (
                            <div key={i} style={{ width: '20px', height: '20px', borderRadius: '50%', backgroundColor: 'white', opacity: 0.8 }}></div>
                        ))}
                    </div>

                    <button className="speak-button" onClick={() => speak(item.word)} style={{ marginTop: '20px' }}>🔊 Speak</button>
                </div>

                <div className="detail-controls">
                    <button className="nav-arrow" onClick={handlePrev}><ArrowLeft size={32} /></button>
                    <button className="nav-arrow" onClick={handleNext}><ArrowRight size={32} /></button>
                </div>
            </div>
        </Layout>
    );
};

export default NumberDetail;
